function scrollToRef(ref) {
  if (ref !== null && ref.current != null) {
    window.scrollTo(0, ref.current.offsetTop)
  }
}

export { scrollToRef }
